import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  Typography,
  Button,
  FormHelperText,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import "./YourProfile.css";
import {
  startOverAPICall,
  stageDetailsAPICall,
  NRIProfileDetailsAPICall,
  NRIPassportDetailsAPICall,
} from "../shared/APICalls";
import {
  INRIProfileDetails,
  IPassportDetails,
  IYourProfileDetails,
  IYourProfilePrefillData,
} from "../shared/dtos";
import routesData from "../shared/routes.json";
import ProfileStyles from "../pages/Styles/PassportStyles.module.scss";
import StageLayout from "../Layouts/StageLayout";
import icon from "../Components/assets/Images/iconnew.svg";
import BackDrop from "../Components/BackDrop";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import calenderImage from "../Components/assets/Images/calendar.svg";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { confirmAlert } from "react-confirm-alert";
import keyboardicon from "../Components/assets/Images/profileicongrey.svg";
import backicon from "../Components/assets/Images/back.svg";
import { useDispatch } from "react-redux";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";

function DateIcon(props) {
  return <img src={calenderImage} style={{ width: "25px" }} />;
}
const today: any = dayjs().startOf("day").toDate();

const schema = Yup.object().shape({
  passportName: Yup.string()
    .required("Name is Required")
    .max(50)
    .matches(/^[a-zA-Z ]*$/, "Enter Valid Name")

    .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
    .transform((value: any) => value && value.toUpperCase()),

  placeofIssue: Yup.string()
    .required("Place of Issue is Required")
    .max(50, "Place of Issue should be at most 50 characters")
    .min(3, "Minmum 3 letters is required")
    .matches(/^[a-zA-Z ]*$/, "Enter Valid Place")
    .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
    .transform((value: any) => value && value.toUpperCase()),
  passportNumber: Yup.string()
    .required("Passport Number is Required")
    .max(30, "Passport Number should be at most 30 characters")
    .matches(/^[a-zA-Z0-9 ]*$/, "Only alphabets, numbers are allowed")
    .matches(/^(?!.*\s{1,}).*$/, "Spaces are not allowed")
    // .matches(/^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/, "Enter Valid Passport Number")
    .transform((value: any) => value && value.toUpperCase()),
  dateofIssue: Yup.date()
    .typeError("Enter a valid Date of Issue")
    .required("Date of Issue is a required ")
    .max(today, "Date of Issue must be before today"),
  validity: Yup.date()
    .typeError("Enter a valid Validity date")
    .required("Date of Issue is a required ")
    .min(
      dayjs().add(1, "day").startOf("day").toDate(),
      "Validity must be in the future"
    ),
});

export default function PassportDetails() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //Loaders
  const [loading, setloading] = useState(false);
  const [prefilloading, setprefilloading] = useState(true);

  const [startOverloading, setstartOverloading] = useState(false);

  const [prefillData, setprefillData] = useState<IPassportDetails>({
    passportName: "",
    dateofIssue: null,
    validity: null,
    placeofIssue: "",
    passportNumber: "",
  });
  const [noeditableData, setnoEditableData] = useState<any>([]);
  const [backdrop, setBackDrop] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");

  const navigationData = routesData;
  const maxDate = dayjs("1940-01-01");

  const renderYear = (year) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {year - maxDate.year()}
      </div>
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);
    let obj: any = {
      stage: "passport_details",
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        setprefilloading(false);

        const responseData = response.data;

        dispatch(setCompletedStages(responseData?.data?.completed_stages));
        dispatch(setCurrentStage(responseData?.data?.current_stage));
        setRejectMessage(response.data.data.ErrorMessage);
        if (response.data.data.data) {
          const PassportDATA = response.data.data.data;
          setprefillData({
            passportName: PassportDATA.Name_as_per_passport,
            dateofIssue: PassportDATA.date_of_issue
              ? dayjs(PassportDATA.date_of_issue)
              : null,
            validity: PassportDATA.validity
              ? dayjs(PassportDATA.validity)
              : null,
            placeofIssue: PassportDATA.place_of_issue,
            passportNumber: PassportDATA.passport_number,
          });
        }
      })
      .catch((error: any) => {
        setprefilloading(false);
      });
  }, []);

  const DateFormated = (value: any) => {
    const date = new Date(value.$d);
    const formattedDate = date.toLocaleDateString("en-GB", {
      year: "numeric",
      day: "2-digit",
      month: "2-digit",
    });
    const [month, day, year] = formattedDate.split("/");
    const formatDate = `${year}-${day}-${month}`;
    return formatDate;
  };

  function yourProfile(data: any) {
    setloading(true);
    let obj: any = {
      validity: DateFormated(data.validity),
      date_of_issue: DateFormated(data.dateofIssue),
      Name_as_per_passport: data.passportName.toUpperCase(),
      place_of_issue: data.placeofIssue.toUpperCase(),
      passport_number: data.passportNumber,
    };

    NRIPassportDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // console.log(responseData);
        setloading(false);
        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
      });
  }

  const handleStartOver = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setBackDrop(true);
            setstartOverloading(true);
            startOverAPICall()
              .then((response: any) => {
                const responseData = response.data;
                // console.log("responseData", response);
                setstartOverloading(false);
                setBackDrop(false);
                navigate("/");
                window.location.reload();
              })
              .catch((error: any) => {
                setBackDrop(false);
                setstartOverloading(false);
              });
          },
        },
      ],
    });
  };
  const initialValues: IPassportDetails = {
    passportName: prefillData.passportName,
    dateofIssue: prefillData.dateofIssue,
    validity: prefillData.validity,
    placeofIssue: prefillData.placeofIssue,
    passportNumber: prefillData.passportNumber,
  };

  //console.log("prefillData" , prefillData)

  return (
    <div className={ProfileStyles.mainWrapper}>
      <div className={ProfileStyles.wrapper}>
        <div
          className={ProfileStyles.backTop}
          onClick={() => {
            navigate("/yourprofile");
          }}
        >
          <img src={backicon} />{" "}
          <span className={ProfileStyles.backText}>Back</span>
        </div>
        <div className={ProfileStyles.step}>
          <img src={keyboardicon} /> Step 3 of 10
        </div>
        <div className={ProfileStyles.leftContainer}>
          <div className={ProfileStyles.headerSection}>
            <p className={ProfileStyles.signup}>Passport Details</p>
          </div>
          {!prefilloading ? (
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={(values: any) => {
                // console.log("values", values);
                yourProfile(values);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
              }) => {
                console.log("errors", errors);
                return (
                  <form
                    noValidate
                    onSubmit={handleSubmit}
                    onKeyDown={(event) => {
                      event.code === "Enter" && handleSubmit();

                      // event.code.includes("Enter") && handleSubmit()
                    }}
                  >
                    <div className={ProfileStyles.contentWrapper}>
                      <div className={ProfileStyles.topContainer}>
                        <div className={ProfileStyles.textFeildWrapper}>
                          <TextField
                            className={ProfileStyles.textfield}
                            id="outlined-basic"
                            label="Passport Number"
                            variant="outlined"
                            name="passportNumber"
                            value={
                              values.passportNumber &&
                              values.passportNumber.toUpperCase()
                            }
                            error={
                              touched.passportNumber &&
                              Boolean(errors.passportNumber)
                            }
                            helperText={
                              touched.passportNumber &&
                              errors.passportNumber?.toString()
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            inputProps={{
                              sx: {
                                "&::label": {
                                  fill: "#111827",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                },
                                color: "var(--Black-Black-500, #6B7280)",
                                fontSize: "14px",
                              },
                              maxLength: 50,
                              inputMode: "text",
                            }}
                            sx={{
                              fieldset: {
                                borderColor: "#E5E7EB",
                                borderRadius: "100px",
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                color: "#6B7280",
                                fontWeight: 400,
                                fontSize: "14px",
                                "&.MuiFormLabel-filled": {
                                  color: "#111827",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                },
                              },
                            }}
                          />
                        </div>

                        <div className={ProfileStyles.textFeildWrapper}>
                          <TextField
                            className={ProfileStyles.textfield}
                            id="outlined-basic"
                            label="Name as per Passport"
                            variant="outlined"
                            name="passportName"
                            value={
                              values.passportName &&
                              values.passportName.toUpperCase()
                            }
                            error={
                              touched.passportName &&
                              Boolean(errors.passportName)
                            }
                            helperText={
                              touched.passportName &&
                              errors.passportName?.toString()
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            inputProps={{
                              sx: {
                                "&::label": {
                                  fill: "#111827",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                },
                                color: "var(--Black-Black-500, #6B7280)",
                                fontSize: "14px",
                              },
                              maxLength: 50,
                            }}
                            sx={{
                              fieldset: {
                                borderColor: "#E5E7EB",
                                borderRadius: "100px",
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                color: "#6B7280",
                                fontWeight: 400,
                                fontSize: "14px",
                                "&.MuiFormLabel-filled": {
                                  color: "#111827",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                },
                              },
                            }}
                          />
                        </div>
                      </div>

                      <div className={ProfileStyles.topContainer}>
                        <div className={ProfileStyles.textFeildWrapper}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              className={ProfileStyles.datePicker}
                              components={{ OpenPickerIcon: DateIcon }}
                              format="DD/MM/YYYY"
                              renderYear={renderYear}
                              views={["year", "month", "day"]}
                              label="Date of Issue"
                              name="dateofIssue"
                              value={values.dateofIssue}
                              onChange={(date) => {
                                handleChange({
                                  target: {
                                    name: "dateofIssue",
                                    value: date,
                                  },
                                });
                                //  console.log("date", date);
                              }}
                              maxDate={dayjs().add(-1, "day")}
                              onBlur={handleBlur}
                              error={
                                touched.dateofIssue &&
                                Boolean(errors.dateofIssue)
                              }
                              helperText={
                                touched.dateofIssue && errors.dateofIssue
                              }
                              renderInput={(params: any) => (
                                <TextField {...params} />
                              )}
                              {...(DatePicker as any)}
                              InputLabelProps={{
                                sx: {
                                  color: "grey", // Default label color
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  "&.MuiFormLabel-filled": {
                                    color: "#111827", // Label color when a value is selected
                                  },
                                },
                              }}
                              sx={{
                                width: "100%",
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                },
                                "& .MuiInputLabel-root": {
                                  color: "#6B7280", // Default label color for date picker
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  "&.Mui-focused": {
                                    color: "#111827",
                                  },
                                  "&.MuiFormLabel-filled": {
                                    color: "#111827",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                  },
                                },
                                "& .MuiOutlinedInput-input": {
                                  color: "var(--Black-Black-500, #6B7280)",
                                  fontSize: "14px",
                                },
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText
                            style={{ color: "#d32f2f", marginLeft: "13px" }}
                          >
                            {touched.dateofIssue &&
                              errors.dateofIssue?.toString()}
                          </FormHelperText>
                        </div>

                        <div className={ProfileStyles.textFeildWrapper}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              className={ProfileStyles.datePicker}
                              components={{ OpenPickerIcon: DateIcon }}
                              format="DD/MM/YYYY"
                              renderYear={renderYear}
                              views={["year", "month", "day"]}
                              label="Validity"
                              name="validity"
                              value={values.validity}
                              onChange={(date) => {
                                handleChange({
                                  target: {
                                    name: "validity",
                                    value: date,
                                  },
                                });
                                //  console.log("date", date);
                              }}
                              minDate={dayjs().add(1, "day")}
                              onBlur={handleBlur}
                              error={
                                touched.validity && Boolean(errors.validity)
                              }
                              // helperText={touched.validity && errors.validity}
                              renderInput={(params: any) => (
                                <TextField {...params} />
                              )}
                              {...(DatePicker as any)}
                              InputLabelProps={{
                                sx: {
                                  color: "grey", // Default label color
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  "&.MuiFormLabel-filled": {
                                    color: "#111827", // Label color when a value is selected
                                  },
                                },
                              }}
                              sx={{
                                width: "100%",
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                },
                                "& .MuiInputLabel-root": {
                                  color: "#6B7280", // Default label color for date picker
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  "&.Mui-focused": {
                                    color: "#111827",
                                  },
                                  "&.MuiFormLabel-filled": {
                                    color: "#111827",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                  },
                                },
                                "& .MuiOutlinedInput-input": {
                                  color: "var(--Black-Black-500, #6B7280)",
                                  fontSize: "14px",
                                },
                              }}
                            />
                          </LocalizationProvider>
                          <FormHelperText
                            style={{ color: "#d32f2f", marginLeft: "13px" }}
                          >
                            {touched.validity && errors.validity?.toString()}
                          </FormHelperText>
                        </div>
                      </div>

                      <div className={ProfileStyles.topContainer}>
                        <div className={ProfileStyles.textFeildWrapper}>
                          <TextField
                            className={ProfileStyles.textfield}
                            id="outlined-basic"
                            label="Place of Issue"
                            variant="outlined"
                            name="placeofIssue"
                            value={
                              values.placeofIssue &&
                              values.placeofIssue.toUpperCase()
                            }
                            error={
                              touched.placeofIssue &&
                              Boolean(errors.placeofIssue)
                            }
                            helperText={
                              touched.placeofIssue &&
                              errors.placeofIssue?.toString()
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            inputProps={{
                              sx: {
                                "&::label": {
                                  fill: "#111827",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                },
                                color: "var(--Black-Black-500, #6B7280)",
                                fontSize: "14px",
                              },
                              maxLength: 50,
                            }}
                            sx={{
                              fieldset: {
                                borderColor: "#E5E7EB",
                                borderRadius: "100px",
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                color: "#6B7280",
                                fontWeight: 400,
                                fontSize: "14px",
                                "&.MuiFormLabel-filled": {
                                  color: "#111827",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                },
                              },
                            }}
                          />
                        </div>
                        <div className={ProfileStyles.textFeildWrapper}>
                          {/* <TextField
                            className={ProfileStyles.textfield}
                            id="outlined-basic"
                            label="Place of Issue"
                            variant="outlined"
                            name="placeofIssue"
                            value={
                              values.placeofIssue &&
                              values.placeofIssue.toUpperCase()
                            }
                            error={
                              touched.placeofIssue &&
                              Boolean(errors.placeofIssue)
                            }
                            helperText={
                              touched.placeofIssue &&
                              errors.placeofIssue?.toString()
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            inputProps={{ maxLength: 50 }}
                          /> */}
                        </div>
                      </div>

                      <ErrorSnackBar message={rejectMessage} />
                      {backdrop && <StartOverBackDrop />}
                      <div className={ProfileStyles.buttonStack}>
                        {values.passportName &&
                        values.dateofIssue &&
                        values.validity &&
                        values.placeofIssue &&
                        values.passportNumber ? (
                          <LoadingButton
                            loading={loading}
                            variant="contained"
                            type="submit"
                            id="yourProfileContinueButton"
                            onClick={() => {
                              handleSubmit();
                            }}
                            className={ProfileStyles.approveButton}
                            sx={{ height: "50px" }}
                          >
                            Continue
                          </LoadingButton>
                        ) : (
                          <Button
                            variant="contained"
                            disabled
                            sx={{ height: "50px" }}
                            onClick={() => {
                              handleSubmit();
                            }}
                            className={ProfileStyles.approveButton}
                          >
                            Continue
                          </Button>
                        )}

                        {/* <div className={ProfileStyles.startOverSection}>
                          <img src={icon} className={ProfileStyles.iconImage} />
                          <p className={ProfileStyles.paratext}>
                            {" "}
                            if the above mentioned info not yours
                            <span
                              className={ProfileStyles.startoverbutton}
                              onClick={handleStartOver}
                            >
                              Start Over
                            </span>
                          </p>
                        </div> */}
                      </div>
                    </div>
                  </form>
                );
              }}
            </Formik>
          ) : (
            <div style={{ height: "80vh" }}>
              <BackDrop />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
